import React from 'react'
import { Modal, Select, message } from 'antd'
import { StoresData } from '@a4b/api/src/modules/Monetisation/Offerings/types'

interface GenerateBatchModalProps {
    visible: boolean
    onClose: () => void
    storeList: StoresData[] | null | undefined
    onBatchGenerated: () => void
    generateBatchFn: (storeId: string) => Promise<void>
    loading: boolean
}

const GenerateBatchModal: React.FC<GenerateBatchModalProps> = ({
    visible,
    onClose,
    storeList,
    onBatchGenerated,
    generateBatchFn,
    loading
}) => {
    const [selectedStoreId, setSelectedStoreId] = React.useState<string | undefined>()
    const [isConfirmVisible, setIsConfirmVisible] = React.useState(false)

    const handleGenerate = async () => {
    if (!selectedStoreId) return

    try {
        await generateBatchFn(selectedStoreId)
        onBatchGenerated()
    } catch (error) {
        console.error('Batch generation failed:', error)
    } finally {
        setIsConfirmVisible(false)
        onClose()
    }
}

    const selectedStore = storeList?.find((s) => s.id === selectedStoreId)

    return (
        <>
            <Modal
                title="Generate Batches"
                visible={visible}
                onCancel={onClose}
                onOk={() => selectedStoreId && setIsConfirmVisible(true)}
                okText="Generate"
                confirmLoading={loading}
                okButtonProps={{ disabled: !selectedStoreId }}
            >
                <p>Select a Store to Generate Batches:</p>
                <Select
                    style={{ width: '100%' }}
                    placeholder="Select Store"
                    onChange={setSelectedStoreId}
                    value={selectedStoreId}
                    showSearch
                    filterOption={(input, option) =>
                        (option?.label as string)?.toLowerCase().includes(input.toLowerCase())
                    }
                >
                    {storeList?.map((store) => (
                        <Select.Option key={store.id} value={store.id} label={`${store.title} (${store.id})`}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <span style={{ fontWeight: 500 }}>{store.title}</span>
                                <span style={{ fontSize: 12, color: '#888' }}>ID: {store.id}</span>
                            </div>
                        </Select.Option>
                    ))}
                </Select>
            </Modal>
            <Modal
                title="Confirm Batch Generation"
                visible={isConfirmVisible}
                onCancel={() => setIsConfirmVisible(false)}
                onOk={handleGenerate}
                okText="Yes, Proceed"
                cancelText="Cancel"
                confirmLoading={loading}
            >
                <p>You are about to generate batches for:</p>
                <p>
                    <strong>Store Title:</strong> {selectedStore?.title} (open)
                </p>
                <p><strong>Store ID:</strong> {selectedStoreId}</p>
                <p>Are you sure you want to proceed?</p>
            </Modal>
        </>
    )
}

export default GenerateBatchModal
